import overview from './overview.json';
import remediationSteps from './remediation-steps.json';
import riskDetails from './risk-details.json';
import riskEvidence from './risk-evidence.json';
import riskScoreWidget from './risk-score-widget.json';
import risks from './risks.json';
import vulnerabilities from './vulnerabilities.json';

const en = {
  overview,
  risks,
  riskDetails,
  riskEvidence,
  remediationSteps,
  riskScoreWidget,
  vulnerabilities,
};

export default en;
